
<template>
  <div class="top5f">
    <div class="top5">
      <div class="boxtitle">
        <div class="btitle">
          <span>专家推荐展示区</span>
        </div>
      </div>
      <div class="t5fbox">
        <swiper :options="t5Option">
          <swiper-slide v-for="(item, index) in 5"
                        :key="index">
            <div class="t5box">
              <div class="t5bt1">
                <img src="https://cgp-resource.oss-cn-beijing.aliyuncs.com/Images/Reading/reader.jpg"
                     alt="" />
              </div>
              <div class="t5bt2">
                <span>大好时光读书会——朱煜：让课堂说话</span>
              </div>
              <div class="t5bt3">
                <div class="t5bt3box">
                  <img src="../../../assets/img/reading/t51.png"
                       alt="">
                  <span>立即购买</span>
                </div>
                <div class="t5bt3x"></div>
                <div class="t5bt3box">
                  <img src="../../../assets/img/reading/t52.png"
                       alt="">
                  <span>预约直播</span>
                </div>
                <div class="t5bt3x"></div>
                <div class="t5bt3box">
                  <img src="../../../assets/img/reading/t53.png"
                       alt="">
                  <span>图书介绍</span>
                </div>
              </div>
            </div>
          </swiper-slide>
        </swiper>
        <div class="t5prevbutton el-icon-arrow-left"></div>
        <div class="t5nextbutton el-icon-arrow-right"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      t5Option: {
        slidesPerView: 3,
        slidesPerGroup: 1,
        spaceBetween: 25.5,
        navigation: {
          nextEl: '.t5nextbutton',
          prevEl: '.t5prevbutton',
          disabledClass: 't5-button-disabled'
        }
      },
    }
  }
}
</script>
<style lang="scss" scoped>
.top5f {
    width: 100%;
    height: 510px;
    background: linear-gradient(90deg, #0b5686, #0b8586);
    overflow: hidden;
    .top5 {
        width: 1200px;
        margin: 0 auto;
        .boxtitle {
            width: 100%;
            border-bottom: 1px solid #eee;
            margin: 35px 0;
            .btitle {
                display: inline-block;
                font-size: 26px;
                font-family: Microsoft YaHei;
                font-weight: bold;
                color: #fff;
                line-height: 26px;
                padding: 15px 0;
                border-bottom: 1px solid #fff;
            }
        }
        .t5fbox {
            width: 1200px;
            position: relative;
        }
        .t5nextbutton {
            width: 36px;
            height: 36px;
            line-height: 35px;
            text-align: center;
            background: #ffffff;
            color: #0b8586;
            border: 1px solid #0b8586;
            box-shadow: 3px 5px 10px 0px rgba(0, 0, 0, 0.04);
            border-radius: 50%;
            box-sizing: border-box;
            font-size: 20px;
            position: absolute;
            top: 140px;
            right: -42px;
            z-index: 60;
            cursor: pointer;
        }
        .t5prevbutton {
            width: 36px;
            height: 36px;
            line-height: 35px;
            text-align: center;
            background: #ffffff;
            color: #0b8586;
            border: 1px solid #0b8586;
            box-shadow: 3px 5px 10px 0px rgba(0, 0, 0, 0.04);
            border-radius: 50%;
            font-size: 20px;
            box-sizing: border-box;
            position: absolute;
            top: 140px;
            left: -42px;
            z-index: 60;
            cursor: pointer;
        }
        .t5-button-disabled {
            font-size: 20px;
            width: 36px;
            height: 36px;
            line-height: 35px;
            text-align: center;
            background: #ffffff3e;
            color: #fff;
            border: 1px solid #fff;
            box-shadow: 3px 5px 10px 0px rgba(0, 0, 0, 0.04);
            border-radius: 50%;
            box-sizing: border-box;
            cursor: auto;
        }
        .t5box {
            width: 383px;
            height: 317px;
            border-radius: 5px;
            display: flex;
            flex-direction: column;
            align-items: center;
            overflow: hidden;
            background-color: #fff;
            .t5bt1 {
                width: 383px;
                height: 215px;
                margin-bottom: 5px;
                img {
                    width: 100%;
                    height: 100%;
                }
            }
            .t5bt2 {
                margin-left: 10px;
                width: 363px;
                font-size: 16px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #000000;
                line-height: 50px;
            }
            .t5bt3 {
                display: flex;
                justify-content: space-between;
                align-items: center;
                width: 340px;
                margin-top: 7px;
                .t5bt3box {
                    display: flex;
                    align-items: center;
                    font-size: 14px;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    color: #0b8586;
                    cursor: pointer;
                    img {
                        margin-right: 8px;
                    }
                }
                .t5bt3x {
                    width: 1px;
                    height: 14px;
                    background: #e5e5e5;
                }
            }
        }
    }
}
</style>